<template>
  <div class="card bg-transparent shadow-xl">
    <div
      class="overflow-hidden position-relative border-radius-xl"
      :style="{backgroundImage: 'url(' + require('../../assets/img/cover-about.png') + ')'}"
    >
      <span class="mask bg-gradient-dark"></span>
      <div class="card-body position-relative z-index-1 p-3">
        <i class="fas fa-dollar-sign text-white p-2" aria-hidden="true"></i>
        <h5
          class="text-white mt-4 mb-5 pb-2"
        >Programa: {{ programa }}</h5>
        <div class="d-flex">
          <div class="d-flex">
            <div :class="this.$store.state.isRTL ? 'ms-4' : 'me-4'">
              <p class="text-white text-sm opacity-8 mb-0">Periodicidad</p>
              <h6 class="text-white mb-0">{{ periodicidad }}</h6>
            </div>
            <div class="me-4">
              <p class="text-white text-sm opacity-8 mb-0">Inicio</p>
              <h6 class="text-white mb-0">{{ inicio }}</h6>
            </div>
            <div>
              <p class="text-white text-sm opacity-8 mb-0">Fin</p>
              <h6 class="text-white mb-0">{{ fin }}</h6>
            </div>
          </div>
          <div
            class="w-20 align-items-end justify-content-end"
            :class="this.$store.state.isRTL ? 'me-auto' : 'ms-auto'"
          >
          <p class="text-white text-sm opacity-8 mb-0">Tarifa</p>
            <!-- <argon-avatar class="w-60 mt-2" :img="img1" alt="logo" /> -->
            <h6 class="text-white mb-0">{{ tarifa }} <small class="opacity-4" v-if="tarifa">x persona</small></h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ArgonAvatar from "@/components/ArgonAvatar.vue";
import img from "../../assets/img/cover-about.png";
import img1 from "../../assets/img/logos/mastercard.png";

export default {
  name: "master-card",
  components: {
    // ArgonAvatar,
  },
  props: {
    programa: {
      type: String
    },
    periodicidad: {
      type: String,
      default: "",
    },
    inicio: {
      type: String,
      default: "",
    },
    fin: {
      type: String,
      default: "",
    },
    tarifa: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      img,
      img1,
    };
  },
};
</script>
